// extracted by mini-css-extract-plugin
module.exports = {"modulesListContainer":"ModuleList_modulesListContainer__2c1Gi"};